import { choiceGroups, choicePromptFor, workerChoiceLabel, workerChoiceLabelUnderAi } from '../lib/command-chat';
import type { WorkerChoice } from '../lib/data';
import '../chat.css';

/**
 * The choices that answer a held draft, drawn the same in Command and in the Plans drawer.
 * Each button is the go-ahead for that Worker with that AI. Choices that would use different
 * AIs are set out under the AI each would use, so the owner picks the AI and then the Worker.
 */
export function HeldDraftChoices({ choices, prompt, busy, buttonClassName, onChoose }: {
  readonly choices: readonly WorkerChoice[];
  /** The line above the choices. Absent, the usual line for these choices. */
  readonly prompt?: string | undefined;
  readonly busy: boolean;
  readonly buttonClassName?: string | undefined;
  readonly onChoose: (workerNumber: number) => void;
}) {
  if (choices.length === 0) return null;
  const groups = choiceGroups(choices);
  const byAi = groups.length > 1;
  return (
    <div className="stack" role="group" aria-label="Choose who does this">
      <small className="muted">{prompt ?? choicePromptFor(choices)}</small>
      {groups.map((group) => (
        <div key={group.ai ?? ''} className="row wrap">
          {byAi && <span className="choice-ai">{group.ai ?? 'AI not recorded'}</span>}
          {group.choices.map((choice) => (
            <button key={choice.workerNumber} type="button" className={buttonClassName} disabled={busy}
              aria-label={workerChoiceLabel(choice)} onClick={() => onChoose(choice.workerNumber)}>
              {byAi ? workerChoiceLabelUnderAi(choice) : workerChoiceLabel(choice)}
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}
